import React from 'react'
import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

import type { FC } from 'react'

export type ContentMasterDetailLayoutProps = {
  children: React.ReactNode
}

/**
 * By defining an interface HeaderStatic, we can extend the FC<HeaderProps> type
 * with the additional static properties (Start, Main, End)
 **/
type ContentLayoutMasterDetailStatic = {
  Master: typeof Master
  Detail: typeof Detail
}

const ContentMasterDetailLayout: FC<ContentMasterDetailLayoutProps> & ContentLayoutMasterDetailStatic = ({
  children,
}: ContentMasterDetailLayoutProps) => {
  return (
    <StContentLayout>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          const { type } = child
          if (type === Master || type === Detail) {
            return child
          }
        }

        return null
      })}
    </StContentLayout>
  )
}

const StContentLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-template-areas:
    'aside'
    'main'
    'aside-again';

  @media ${breakpoints.m} {
    grid-gap: 30px;
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'aside main'
      'aside-again main';
  }

  @media ${breakpoints.l} {
    grid-template-columns: 2fr 3fr;
  }
`

const Master = styled.div`
  grid-area: aside;
`

const Detail = styled.div`
  grid-area: main;
`

ContentMasterDetailLayout.Master = Master
ContentMasterDetailLayout.Detail = Detail

export { ContentMasterDetailLayout }
